import { ChangeEvent, useState } from "react";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  Typography,
  Chip,
  CardMedia,
  Input,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import SwitchToggle from "../../components/SwitchToggle";
import CommentIcon from '@mui/icons-material/Comment';
import SelectUpload from "../../Modals/select_upload";
const AddProductEnhanced = () => {
  const navigate = useNavigate();
  const [type, setType] = useState("default");
  const [vendor, setVendor] = useState("default");
  const [brand, setBrand] = useState("default");
  const [images, setImages] = useState<(string | null)[]>(Array(8).fill(null));

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleTypeChange = (event: any) => {
    setType(event.target.value as string);
  };

  // ✅ Color and Size state
  const [selectedColors, setSelectedColors] = useState<string[]>([
    "Red",
    "Blue",
    "Green",
  ]);
  const [selectedSizes, setSelectedSizes] = useState<string[]>([
    "XS",
    "S",
    "M",
    "L",
    "XL",
    "XXL",
  ]);

  // ✅ Selection handler for colors
  const handleColorClick = (color: string) => {
    setSelectedColors((prev) =>
      prev.includes(color)
        ? prev.filter((c) => c !== color)
        : [...prev, color]
    );
  };

  // ✅ Selection handler for sizes
  const handleSizeClick = (size: string) => {
    setSelectedSizes((prev) =>
      prev.includes(size)
        ? prev.filter((s) => s !== size)
        : [...prev, size]
    );
  };

  const handleImageChange = (
    event: ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      const newImages = [...images];
      newImages[index] = imageUrl;
      setImages(newImages);
    }
  };

  const handleRemoveImage = (index: number) => {
    const newImages = [...images];
    newImages[index] = null;
    setImages(newImages);
  };
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");
  // By default, first image is featured
  const [featuredIndex, setFeaturedIndex] = useState<number>(0);
  // const handleRemoveImage = (index: number) => {
  //   const newImages = [...images];
  //   newImages.splice(index, 1);
  //   setImages(newImages);

  //   // Update featuredIndex if needed
  //   if (featuredIndex === index) {
  //     setFeaturedIndex(newImages.length > 0 ? 0 : null);
  //   } else if (featuredIndex > index) {
  //     setFeaturedIndex(featuredIndex - 1);
  //   }
  // };
  const [isFeatured, setIsFeatured] = useState(false);
  const handleToggleFeatured = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsFeatured(e.target.checked);
  };

  const [group, setGroup] = useState("");
  const [tags, setTags] = useState<string[]>([]);

  return (
    <>
      {/* 🟦 Page Header */}
      <div className="main_title">
        <h1>Add Product</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-products")}>
            Manage Products
          </button>
          - Add Product
        </p>
      </div>

      {/* 🟦 Product Form */}
      <div className="cards custom_form_details">
        <div className="form">
          <div className="gap_m w_100">
            <div className="control_group w_33">
              <label htmlFor="product-name">Product Name</label>
              <TextField placeholder="Enter here" fullWidth hiddenLabel inputProps={{ id: "product-name" }} />
            </div>

            <div className="control_group w_33">
              <label htmlFor="vendor-selection">Vendor</label>
              <Select fullWidth value={vendor} onChange={(e: any) => setVendor(e.target.value as string)} inputProps={{ id: "vendor-selection" }}>
                <MenuItem disabled value="default">
                  Select Vendor
                </MenuItem>
                <MenuItem value="vendor1">Vendor 1</MenuItem>
                <MenuItem value="vendor2">Vendor 2</MenuItem>
              </Select>
            </div>

            <div className="control_group w_33">
              <label htmlFor="brand-selection">Brand</label>
              <Select fullWidth value={brand} onChange={(e: any) => setBrand(e.target.value as string)} inputProps={{ id: "brand-selection" }}>
                <MenuItem disabled value="default">
                  Select Brand
                </MenuItem>
                <MenuItem value="brand1">Brand 1</MenuItem>
                <MenuItem value="brand2">Brand 2</MenuItem>
              </Select>
            </div>

            <div className="control_group w_33">
              <label htmlFor="product-category">Product Category <img className="cr_pt" src="/static/images/ai_icon.svg" alt="icon" /> </label>
              <Select fullWidth value={type} onChange={handleTypeChange} inputProps={{ id: "product-category" }}>
                <MenuItem disabled value="default">
                  Select Category
                </MenuItem>
                <MenuItem value="category1">Category1</MenuItem>
                <MenuItem value="category2">Category2</MenuItem>
              </Select>
            </div>

            <div className="control_group w_33">
              <label htmlFor="product-subcategory">Product Sub-Category <img className="cr_pt" src="/static/images/ai_icon.svg" alt="icon" /></label>
              <Select fullWidth value={type} onChange={handleTypeChange} inputProps={{ id: "product-subcategory" }}>
                <MenuItem disabled value="default">
                  Select Sub-Category
                </MenuItem>
                <MenuItem value="subcategory1">Sub-Category1</MenuItem>
              </Select>
            </div>


            {/* Group */}
            <div className="control_group w_33">
              <label htmlFor="product-group">Group</label>

              <TextField
                select
                fullWidth
                hiddenLabel
                value={group}
                onChange={(e) => setGroup(e.target.value)}
                inputProps={{ id: "product-group" }}
              >
                <MenuItem value="" disabled>
                  Select Group
                </MenuItem>
                <MenuItem value="products">Products</MenuItem>
                <MenuItem value="stores">Stores</MenuItem>
                <MenuItem value="categories">Categories</MenuItem>
              </TextField>
            </div>

            {/* Tags */}
            <div className="control_group w_33">
              <label htmlFor="product-tags">
                Tags
                <img
                  className="cr_pt"
                  src="/static/images/ai_icon.svg"
                  alt="icon"
                />
              </label>

              <TextField
                select
                fullWidth
                hiddenLabel
                value={tags}             
                onChange={(e) =>
                  setTags(
                    typeof e.target.value === "string"
                      ? e.target.value.split(",")
                      : e.target.value
                  )
                }
                SelectProps={{ multiple: true }}
                inputProps={{ id: "product-tags" }}
              >
                <MenuItem value="selling_fast">Selling Fast</MenuItem>
                <MenuItem value="new_arrival">New Arrival</MenuItem>
                <MenuItem value="best_seller">Best Seller</MenuItem>
                <MenuItem value="limited_stock">Limited Stock</MenuItem>
              </TextField>
            </div>


            <div className="control_group w_100 ai_rec_btn">
              <label htmlFor="product-description">Product Description</label>
              <TextField
                label="Product Description*"
                fullWidth
                multiline
                minRows={4}
                placeholder="Enter product description..."
                inputProps={{ id: "product-description" }}
              />
              <Button className="btn btn_primary sm">
                <img src="/static/images/ai_icon.svg" alt="" />
                Enhance with AI
              </Button>
            </div>
          </div>



        </div>
      </div>

      {/* 🟦 Attributes Section */}
      <div className="cards variants">
        <Box sx={{ borderRadius: 2 }}>
          <Typography variant="h6" fontWeight={600} mb={2}>
            Add Attributes
          </Typography>


          {/* ✅ Color Chips */}
          <div className="select_variant">
            <Typography variant="subtitle1" fontWeight={500}>
              <SwitchToggle /> Colour
            </Typography>

            <Box display="flex" gap={1} mt={1}>
              {["Red", "Green", "Blue", "Yellow", "Black"].map((color) => {
                const isSelected = selectedColors.includes(color);
                return (
                  <Chip
                    key={color}
                    label={color}
                    onClick={() => handleColorClick(color)}
                    clickable
                    sx={{
                      backgroundColor: isSelected ? "#D3B88C" : "transparent",
                      color: isSelected ? "#fff" : "inherit",
                      borderColor: "#D3B88C",
                      "&:hover": {
                        backgroundColor: isSelected
                          ? "#1565c0"
                          : "rgba(25,118,210,0.1)",
                      },
                    }}
                    variant="outlined"
                  />
                );
              })}
            </Box>
          </div>

          {/* ✅ Size Chips */}
          <div className="select_variant">
            <Typography variant="subtitle1" fontWeight={500}>
              <SwitchToggle /> Size
            </Typography>

            <Box display="flex" gap={1} mt={1}>
              {["XS", "S", "M", "L", "XL", "XXL"].map((size) => {
                const isSelected = selectedSizes.includes(size);
                return (
                  <Chip
                    key={size}
                    label={size}
                    onClick={() => handleSizeClick(size)}
                    clickable
                    sx={{
                      backgroundColor: isSelected ? "#D3B88C" : "transparent",
                      color: isSelected ? "#fff" : "inherit",
                      borderColor: "#D3B88C",
                      "&:hover": {
                        backgroundColor: isSelected
                          ? "#1565c0"
                          : "rgba(25,118,210,0.1)",
                      },
                    }}
                    variant="outlined"
                  />
                );
              })}
            </Box>
          </div>
        </Box>

        <Button className="btn btn_primary">Create Variant</Button>

        {/* 🟦 Example Variant Details */}
        <div className="create_variant mt_20">
          <ul>
            <li>
              <strong>Colour</strong> Black
            </li>
            <li>
              <strong>Size</strong> L
            </li>
            <li>
              <Button>
                <DeleteIcon />
              </Button>
            </li>
          </ul>

          <div className="form">
            <div className="gap_m">
              <div className="control_group w_33">
                <label htmlFor="variant-name">Variant Name</label>
                <TextField placeholder="Enter Variant Name" fullWidth inputProps={{ id: "variant-name" }} />
              </div>

              <div className="control_group w_33">
                <label htmlFor="variant-price">Price  <img className="cr_pt" src="/static/images/ai_icon.svg" alt="" /></label>
                <TextField placeholder="Enter Price" fullWidth inputProps={{ id: "variant-price" }} />
              </div>

              <div className="control_group w_33">
                <label htmlFor="variant-discounted-price">Discounted Price</label>
                <TextField placeholder="Enter Discounted Price" fullWidth inputProps={{ id: "variant-discounted-price" }} />
              </div>
            </div>
          </div>

          {/* 🟦 Product Images */}
          <Typography variant="subtitle1" fontWeight={500} mt={3}>
            Product Images or Videos* <img className="cr_pt" src="/static/images/ai_icon.svg" alt="" />
          </Typography>

          <div className="gap_p">
            <div className="control_group wrap_viewDemo_steps w_100">
              <label htmlFor="">Upload</label>
              <div className="upload_box">
                <label className='upload_action' onClick={() => setOpenModal(true)} style={{ minHeight: "195px" }}>
                  <p>
                    <img src="/static/images/upload_icon.svg" alt='icon' />
                    <strong>Click to upload image or take photo</strong>
                  </p>
                </label>
              </div>
            </div>
            {images.map((image, i) => (
              <div key={i} className="control_group w_17">
                <label htmlFor="" className="featured">Make Featured</label>
                {image ? (
                  <div className="upload_image">
                    <div className="upload_image_holder no_radius">

                      {/* IMAGE */}
                      <figure>
                        <CardMedia component="img" image={image} alt={`photo-${i}`} />
                      </figure>

                      {/* FEATURED TAG */}
                      {featuredIndex === i && (
                        <span className="featured_tag">Featured</span>
                      )}

                      {/* REMOVE IMAGE */}
                      <CloseIcon onClick={() => handleRemoveImage(i)} />

                      {/* SET AS FEATURED BUTTON */}
                      <button
                        type="button"
                        className={`featured_btn ${featuredIndex === i ? "active" : ""}`}
                        onClick={() => setFeaturedIndex(i)}
                      >
                        {featuredIndex === i ? "Featured" : "Set Featured"}
                      </button>

                    </div>
                  </div>
                ) : (
                  <label className="upload_image" htmlFor={`icon-button-file-${i}`}>

                    {featuredIndex === i && (
                      <span className="featured_tag">Featured</span>
                    )}
                    <span className="upload_image_holder no_radius">
                      <figure className="add_img">
                        <img src="/static/images/placeholder.png" alt="icon" />
                        <span className="upload_img_icon delete_icon">
                          <img src="/static/images/trash2_icon.svg" alt="edit" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}

              </div>
            ))}
          </div>

        </div>

      </div>
      <div className="cards">
        <Grid item xs={12}>
          <Box display="flex" gap={2} flexDirection="column" >

            <Box display="flex" gap={2}>

              Add Product as Featured Products
              <SwitchToggle
              />

            </Box>

          </Box>
        </Grid>
      </div>
      <div className="cards">
        <Box sx={{ borderRadius: 2 }}>
          <Typography variant="h5" fontWeight={600} mb={2}>
            Product Promotion  <Typography variant="h6" fontWeight={400}> </Typography>
          </Typography>

        </Box>
        <div className="form mt_20">
          {/* 🟦 Product Images */}
          <Typography variant="subtitle1" fontWeight={500} mt={3}>
            Product Reels <img className="cr_pt" src="/static/images/ai_icon.svg" alt="" />
          </Typography>
          <div className="gap_p ">
            <div className="control_group wrap_viewDemo_steps w_100">
              <div className="upload_box">
                <label className='upload_action' onClick={() => setOpenModal(true)} style={{ minHeight: "195px" }}>
                  <p>
                    <img src="/static/images/upload_icon.svg" alt='icon' />
                    <strong>Click to upload image or take photo</strong>
                  </p>
                </label>
              </div>
            </div>
            <div className="control_group w_17">

              {image ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={image} alt="photo" />
                    </figure>
                    <CloseIcon
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label className="upload_image" htmlFor="icon-button-file">


                  <span className="upload_image_holder no_radius">
                    <figure className="add_img">
                      <img
                        src="/static/images/placeholder.png"
                        alt="icon"
                      />
                      <span className="upload_img_icon">
                        <img src="/static/images/trash2_icon.svg" alt="icon" />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>
            <div className="control_group w_17">
              <label htmlFor="icon-button-file"></label>
              {image ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={image} alt="photo" />
                    </figure>
                    <CloseIcon
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label className="upload_image" htmlFor="icon-button-file">

                  <span className="upload_image_holder no_radius">
                    <figure className="add_img">
                      <img
                        src="/static/images/placeholder.png"
                        alt="icon"
                      />
                      <span className="upload_img_icon">
                        <img src="/static/images/trash2_icon.svg" alt="icon" />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>
            <div className="control_group w_17">
              {image ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={image} alt="photo" />
                    </figure>
                    <CloseIcon
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label className="upload_image" htmlFor="icon-button-file">

                  <span className="upload_image_holder no_radius">
                    <figure className="add_img">
                      <img
                        src="/static/images/placeholder.png"
                        alt="icon"
                      />
                      <span className="upload_img_icon">
                        <img src="/static/images/trash2_icon.svg" alt="icon" />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="w_100 mt_20">
        <Button className="w_100 btn btn_primary" size="large">
          Save
        </Button>
      </div>
      <SelectUpload
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>

  );
};

export default AddProductEnhanced;
